import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { useNavigate } from "react-router";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  PageHeader,
  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import { addRole } from "../../../Services/notifications&rolesServices";

const accessOptions = [
  { label: "Edit", value: "Edit" },
  { label: "View", value: "View" },
];
const accessAllOptions = [
  { label: "View All", value: "View All" },
  { label: "View Own", value: "View Own" },
  { label: "Edit All", value: "Edit All" },
  { label: "Edit Own", value: "Edit Own" },
];
const approveOptions = [{ label: "Approve", value: "approve" }];

const CreateRole = () => {
  const [alert, setAlert] = useState(false);
  const [warningMsg, setWarningMsg] = useState();
  const [message, setMessage] = useState();
  //   const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [prevCheckBoxValues, setPrevCheckBoxValues] = useState(
   {
      global_settings:[],
      machine_records:[],
      product_records:[],
      customer_records:[],
      workflow_settings:[],
      advanced_settings:[],
      packaging_config:[],
      order_records:[],
      approve_orders:[],
      job_cards:[],
      approve_jobcards:[],
      company_profile:[],
      user_management:[],
      plan_details_and_billing:[],
      notifications:[],
      production_job_cards:[],
      jumbo_reels:[],
      prod_details:[],
      stocks:[],
    }
  );

  const onChange = (checkedValues, formItemName) => {
    console.log(checkedValues,formItemName)
  let data = checkedValues;
    if (prevCheckBoxValues[formItemName]?.includes("View") && !checkedValues?.includes("View")) {
      data = [];
    }
    if (!prevCheckBoxValues[formItemName]?.includes("Edit") && checkedValues?.includes("Edit")) {
      data = ["View", "Edit"];
    }
    if (!prevCheckBoxValues[formItemName]?.includes("Edit Own") && checkedValues?.includes("Edit Own")) {
      data = [...checkedValues, "View Own"];
    }
    if (prevCheckBoxValues[formItemName]?.includes("View Own") &&  !checkedValues?.includes("View Own")) {
      data = checkedValues.filter((item) => item != "Edit Own");
    }
    if (!prevCheckBoxValues[formItemName]?.includes("Edit All") &&  checkedValues?.includes("Edit All")) {
      data = [...checkedValues, "View All"];
    }
    if (prevCheckBoxValues[formItemName]?.includes("View All") && !checkedValues?.includes("View All")) {
      data = checkedValues.filter((item) => item != "Edit All");
    }
    form.setFieldsValue({ [formItemName]: data });
    setPrevCheckBoxValues({
      ...prevCheckBoxValues,
      [formItemName]: data,
    });
  };

  //Fuction to return the value of view and edit inside access controls
  const accessControlValue = (value, approveJobCardValue = []) => {
    if (value)
      return {
        view: value.includes("View") || value.includes("Edit") || approveJobCardValue?.includes("approve"),
        edit: value.includes("Edit") && value.includes("View"),
      };
    else
      return {
        view: false,
        edit: false,
      };
  };
  //Fuction to return the value of view own,view all,edit own and edit all inside access controls
  const accessControlOrderRecordCheck = (value, approveOrdersValue) => {
    if (value)
      return {
        view_own: value?.includes("View Own") || value?.includes("Edit Own") || approveOrdersValue?.includes("approve"),
        view_all: value?.includes("View All") || value?.includes("Edit All") || approveOrdersValue?.includes("approve"),
        edit_own: value.includes("Edit Own")  && value.includes("View Own"),
        edit_all: value.includes("Edit All") && value.includes("View All"),
      };
    else
      return {
        view_own: false,
        view_all: false,
        edit_own: false,
        edit_all: false,
      };
  };

  
  const onFinish = async (values) => {
    const body = {
      name: values.roleName.toUpperCase(),
      roles: {
        approve_jobcards: {
          edit:
          values.approve_jobcards &&
          values.approve_jobcards.includes("approve"),
          view: true,
        },
        approve_orders: {
          edit:
          values.approve_orders && values.approve_orders.includes("approve"),
          view: true,
        },
        global_settings: accessControlValue(values.global_settings),
        machine_records: accessControlValue(values.machine_records),
        product_records: accessControlValue(values.product_records),
        customer_records: accessControlValue(values.customer_records),
        workflow_settings: accessControlValue(values.workflow_settings),
        advanced_settings: accessControlValue(values.advanced_settings),
        order_records: accessControlOrderRecordCheck(values.order_records, values.approve_orders),
        job_cards: accessControlValue(values.job_cards, values.approve_jobcards),
        company_profile: accessControlValue(values.company_profile),
        user_management: accessControlValue(values.user_management),
        plan_details_and_billing: accessControlValue(
          values.plan_details_and_billing
        ),
        production: {
          job_cards: accessControlValue(values.production_job_cards),
          jumbo_reels: accessControlValue(values.jumbo_reels),
          prod_details: accessControlValue(values.prod_details),
        },
        packaging_config: accessControlValue(values.packaging_config),
        inventory: {
          stocks: accessControlValue(values.stocks),
        },
        notifications: accessControlValue(values.notifications),
      },
    };

    try {
      const newRole = await addRole(body);
      setAlert(true);
      setWarningMsg(false);
      setMessage(newRole.msg);
      setTimeout(() => {
        navigate("/organization-setting/roles-and-permissions");
      }, 2000);
    } catch (error) {
      setAlert(true);
      setWarningMsg(true);
      setMessage(error.response.data.msg);
    }
  };
  
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  
  const showCancelModal = () => {
    setVisible(true);
  };
  
  const closeCancelModal = () => {
    setVisible(false);
  };
  
  const confirmCancelModal = () => {
    form.resetFields();
    setVisible(false);
    navigate("../roles-and-permissions");
  };
  
  const cancelChangeHandler = () => {
    showCancelModal();
  };

  useEffect(()=>{
    form.setFieldsValue({"notifications":["View"]})
  },[])
  
  return (
    <Form
      name="basic"
      autoComplete="off"
      className="haberLogin"
      initialValues={{
        remember: true,
      }}
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      {alert ? (
        <AlertContainer
          color={warningMsg ? "red" : "green"}
          icon={warningMsg ? alertRed : alertGreen}
          msg={message}
        />
      ) : (
        ""
      )}

      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Create new role"
            onBack={() => window.history.back()}
            extra={[
              <Button
                key="1"
                type="button"
                onClick={() => cancelChangeHandler()}
                className="textTypeBtn"
              >
                Cancel changes
              </Button>,
              <Button
                key="2"
                className="themeBtn"
                type="primary"
                htmlType="submit"
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Create Role
              </Button>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        <DetailFields>
          <HaberForm>
            <div className="groupDetailWrap">
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>Enter general details of the role</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign" gutter={[0,30]}>
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Role Name</label>
                        <p>Enter the name you want to assign to the role</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="roleName"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            }
                          ]}
                          className=""
                        >
                          <Input placeholder="Enter role name" />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="groupForm"
                style={{ borderBottom: "0px" }}
              >
                <Col span={8}>
                  <GroupTitle style={{ marginTop: "10px" }}>
                    <h2>Access Control</h2>
                    <p>This user will have access to selected modules</p>
                  </GroupTitle>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Configurations</h2>
                    <p>User access to configurations can be controlled here</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Global Settings</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="global_settings">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["Edit"]}
                            // checked={isChecked}
                            onChange={(checkedValues)=>onChange(checkedValues,"global_settings")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Machine Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="machine_records">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"machine_records")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Product Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="product_records">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"product_records")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Customer Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="customer_records">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"customer_records")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Workflow Settings</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="workflow_settings">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"workflow_settings")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Advanced Settings</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="advanced_settings">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"advanced_settings")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Packaging Types</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="packaging_config">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"packaging_config")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Order Management</h2>
                    <p>
                      User access to order management can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Order Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="order_records">
                          <Checkbox.Group
                            options={accessAllOptions}
                            // defaultValue={["Edit Own", "Edit All"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"order_records")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Approve Orders</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="approve_orders">
                          <Checkbox.Group
                            options={approveOptions}
                            // defaultValue={["Approve"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Deckle Management</h2>
                    <p>
                      User access to deckle management can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Job Cards</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="job_cards">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"job_cards")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Approve Job Cards</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="approve_jobcards">
                          <Checkbox.Group
                            options={approveOptions}
                            // defaultValue={["Approve"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Organization Settings</h2>
                    <p>
                      User access to organization settings can be controlled
                      here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Company Profile</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="company_profile">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"company_profile")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>User Management</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="user_management">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"user_management")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Plan Details and Billing</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="plan_details_and_billing">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"plan_details_and_billing")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Notifications</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="notifications">
                          <Checkbox.Group
                            options={accessOptions.map((item)=>{
                                if(item.value == "View")
                                    return {
                                        ...item,
                                        disabled:true,
                                    }
                                    else
                                        return item
                            })}
                            // defaultValue={["View"]}
                            // checked={true}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"notifications")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Production Planning</h2>
                    <p>
                      User access to production planning can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Job Cards</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="production_job_cards">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"production_job_cards")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Jumbo Reels</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="jumbo_reels">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"jumbo_reels")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Production Details</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="prod_details">
                          <Checkbox.Group
                            options={accessOptions}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"prod_details")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Stock Management</h2>
                    <p>
                      User access to stock management can be controlled here
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign titleVCenter paddingTB">
                    <Col span={24}>
                      <div className="boxFieldTitle ant-col-8">
                        <label>Stock Records</label>
                      </div>
                      <div className="boxFormType reverseCheckbox">
                        <Form.Item name="stocks">
                          <Checkbox.Group
                            options={accessOptions.map((option)=>{
                              if(option.value == 'Edit')
                                return {
                                  ...option,
                                  disabled:true,
                              }
                              else
                                return option
                            })}
                            // defaultValue={["View"]}
                            // checked={isChecked}
                            // onChange={onChange}
                            onChange={(checkedValues)=>onChange(checkedValues,"stocks")}
                            className="flexRowReverse"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </HaberForm>
        </DetailFields>

        <ConfirmationModal
          visible={visible}
          icon={warning}
          confirmAction={confirmCancelModal}
          cancelAction={closeCancelModal}
        >
          <span>Are you sure?</span>
          <p>
            You have pending changes on this page, are you sure you want to
            leave?
          </p>
        </ConfirmationModal>
      </RightLayoutContainer>
    </Form>
  );
}

export default CreateRole;